
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/rubrics/jst/changePointsPossibleToMatchRubricDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<p title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("change_points_possible_to_match_rubric_dialog")
  },data:data},helper ? helper.call(depth0, "change_points_possible_to_match_rubric_dialog.titles.update_assignment_points", "Change assignment points to match rubric?", options) : helperMissing.call(depth0, "t", "change_points_possible_to_match_rubric_dialog.titles.update_assignment_points", "Change assignment points to match rubric?", options)))
    + "\">\n  ";
  stack1 = (helper = helpers.toPercentage || (depth0 && depth0.toPercentage),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.pointRatio), options) : helperMissing.call(depth0, "toPercentage", (depth0 && depth0.pointRatio), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'toPercentage_pointRatio': (stack1),
    'assignmentPoints': ((depth0 && depth0.assignmentPoints)),
    'rubricPoints': ((depth0 && depth0.rubricPoints)),
    'i18n_scope': ("change_points_possible_to_match_rubric_dialog")
  },data:data},helper ? helper.call(depth0, "change_points_possible_to_match_rubric_dialog.prompts.update_assignment_points", "Leaving the assignment's total points at %{assignmentPoints} and the rubric's total points at %{rubricPoints} will result in a maximum possible score of %{toPercentage_pointRatio} for student submissions graded with the rubric.", options) : helperMissing.call(depth0, "t", "change_points_possible_to_match_rubric_dialog.prompts.update_assignment_points", "Leaving the assignment's total points at %{assignmentPoints} and the rubric's total points at %{rubricPoints} will result in a maximum possible score of %{toPercentage_pointRatio} for student submissions graded with the rubric.", options)))
    + "\n</p>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  